import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Card, Typography } from 'seagull';
import styles from './CardButtonGrid.module.scss';
export function CardButtonGrid(param) {
    let { items, testId } = param;
    return /*#__PURE__*/ _jsx(Box, {
        className: styles.container,
        testId: testId,
        children: items.map((item)=>/*#__PURE__*/ _jsx(Card, {
                as: "button",
                skin: "button",
                highlightOnHover: true,
                padding: "s",
                testId: item.testId,
                bi: item.bi,
                className: styles.card,
                onClick: item.onClick,
                children: /*#__PURE__*/ _jsxs(Box, {
                    className: styles.cardContent,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            weight: "normal",
                            variant: "paragraph1",
                            children: item.title
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: "secondary",
                            variant: "paragraph2",
                            weight: "light",
                            children: item.description
                        })
                    ]
                })
            }, item.title))
    });
}
